import { z } from 'zod';

// age:27
// avatar:"https://everfit-public.s3.ap-southeast-1.amazonaws.com/1698749354829-HR_HA%20MY%20HANG.jpg"
// createdAt:"2021-09-30T02:23:43.463Z"
// dob:"1996-11-05T00:00:00.000Z"
// email:"hangha@everfit.io"
// firstNameSort:"hang"
// first_name:"Hang"
// fullNameSort:"hangha"
// fullTimeStartDate:"2021-09-21T00:00:00.000Z"
// full_name:"Hang Ha"
// insuranceStartDate:"2021-12-21T00:00:00.000Z"
// is_deleted:false
// lastNameSort:"ha"
// last_name:"Ha"
// oneYearAnniversary:"1997-11-05T00:00:00.000Z"
// phone:"+84796577922"
// role:"612f34f070fcf482f27d82ed"
// start_date:"1996-11-05T00:00:00.000Z"
// status:"banned"
// updatedAt:"2023-10-31T11:06:05.536Z"
// team:"61551faf70fcf482f27d830b"
// _id:"61551faf70fcf482f27d830b"

export const userSchema = z.object({
  first_name: z.string().min(1, 'First Name is required'),
  last_name: z.string().min(1, 'Last Name is required'),
  email: z.string().email('Invalid email address'),
  sex: z.string().min(0, 'Team is required'),
  team: z.string().min(1, 'Team is required'),
  dob: z.string().min(1, 'Date of Birth is required'),
  start_date: z.string().min(1, 'Start Date is required'),
  phone: z.string().refine(
    (val) => {
      const phoneRegex =
        /^[+]?[0-9]{1,3}[-\s.]?(\([0-9]{1,3}\)|[0-9]{1,3})[-\s.]?[0-9]{3,4}[-\s.]?[0-9]{3,4}$/;
      return phoneRegex.test(val);
    },
    {
      message: 'Invalid phone number',
    }
  ),
});

export const userFields = Object.keys(userSchema.shape);
